module.exports = __webpack_public_path__ + "static/courgette-d3f9a7d1cc578855426c72ce676406e0.svg";